import React, { FC } from 'react'
import Select, { StylesConfig } from 'react-select'

import { DropdownProps, DropdownOption, DropdownGroup } from '@/types'

const customStyles: StylesConfig<DropdownOption, boolean, DropdownGroup> = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    height: 48,
    border: '1px solid #d2dbe0',
    borderRadius: 2,
    backgroundColor: '#fcfeff',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#171e24',
  }),
}

export const Dropdown: FC<DropdownProps> = ({ styles, ...props }) => (
  <Select styles={{ ...customStyles, ...styles }} {...props} />
)
